import { render } from "./Detail.vue?vue&type=template&id=c3941384"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
script.render = render

export default script